import React, { Component } from 'react'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'

import { 
  fetchReauthenticateMembersAction
} from  '../../actions/Authentification/Reauthenticate'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class HomeMembers extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier")
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Accueil`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, getReauthenticateCourtiers, reauthenticateMembers } = this.props

    if (isCurrentLoginCourtier) {
      getReauthenticateCourtiers()
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
    }
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers } = this.props
    const { isCurrentLoginCourtier} = this.state

    return(
      <div>
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeMembers)



// WEBPACK FOOTER //
// ./src/containers/HomeMembers/index.js